import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { IdocWasteOriginTypes, IdocWasteDestinationTypes } from 'shared-pages/shared/constants';
import { getRouteByName } from 'app/routes';
import { useField } from 'formik';
import { generatePath, Link } from 'react-router-dom';

const gqlGetRec = gql`
  query getWastereceptionpoints($where: String, $offset: Int, $limit: Int, $order: String) {
    getWastereceptionpoints(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetRecLazyQuery() {
  return useLazyQuery(gqlGetRec, { fetchPolicy: 'cache-first' });
  //return [null, { loading: null, data: null }];
}

interface Props extends FsProps {
  onlyRecyclers?: boolean;
  onlySecondaryStorage?: boolean;
  collectorId?: number;
}

export const FieldSelectWasteReceptionPoint = ({
  label = 'Σημείο Παραλαβής Αποβλήτων',
  name = 'wastereceptionpointId',
  defaultValues = {},
  onlyRecyclers = false,
  onlySecondaryStorage = false,
  collectorId = null,
  ...rest
}: Props) => {
  const where = () => {
    let where = null;
    if (onlyRecyclers) where = { wastedestinationtypeId: IdocWasteDestinationTypes.Recycling };
    else if (onlySecondaryStorage)
      where = { wastedestinationtypeId: IdocWasteDestinationTypes.SecondaryStorage };

    if (collectorId) {
      where = { ...where, collectorId };
    }
    return where ? JSON.stringify(where) : null;
  };

  const [field, { value }] = useField(name);
  const path = value ? generatePath(getRouteByName('WasteReceptionPoint'), { id: value }) : '';
  const showLabel = value ? <Link to={path}>{label}</Link> : label;

  return (
    <FieldSelectDB
      {...rest}
      label={showLabel}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.collector?.name ?? undefined}
      hook={useGetRecLazyQuery}
      where={where()}
    />
  );
};

